import { Box, Image } from "@chakra-ui/react";
import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faClock } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineClockCircle } from "react-icons/ai";
import { AiFillHeart } from "react-icons/ai";
import { AiFillFacebook } from "react-icons/ai";

const ImgCard = ({
  raised,
  total,
  quote,
  beneficiary,
  beneficiaryLogo,
  days,
  supporters,
  banner,
}) => {
  let calRaised = raised.trim().split(",").join("");
  // console.log("calRaised:",calRaised)

  let calTotal = total.trim().split(",").join("");
  // console.log("calTotal:",calTotal)

  let raisedPercent = calRaised / calTotal;
  // console.log("raisedPercent:",raisedPercent)

  let raisedLength = raisedPercent * 280;
  // console.log("raisedLength:",raisedLength);
  return (
    <Box h={450} w={320} className="imageCardComponent">
      <Box h={170}>
        <Image h="100%" w="96%" src={banner} />
      </Box>
      <Box h={190} w={320} p="20px 20px 0px">
        <h1
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            textAlign: "left",
            letterSpacing: "-0.5px",
          }}
        >
          {quote}
        </h1>
        <Box
          style={{
            margin: "10px 0px",
            width: "280px",
            height: "32px",
          }}
        >
          <Image
            style={{ borderRadius: "50%", height: "32px", width: "32px" }}
            src={beneficiaryLogo}
          />
          <span
            style={{
              fontSize: "14px",
              position: "relative",
              left: "50px",
              top: "-29px",
            }}
          >
            {beneficiary}
          </span>
        </Box>
        <Box style={{ margin: "0px 0px", marginTop: "0px" }}>
          <span style={{ fontSize: "20px", weight: "bold" }}></span>
          <span
            style={{
              fontSize: "17px",
              fontWeight: "bold",
              lineHeight: "30px",
            }}
          >
            {raised}
          </span>
          <span
            style={{ color: "#999", fontSize: "17px", fontWeight: "normal" }}
          >
            {" "}
            raised out of{" "}
            <span
              style={{
                fontSize: "17px",
                fontWeight: "bold",
                lineHeight: "30px",
                color: "#999",
              }}
            >
              {total}
            </span>
          </span>
        </Box>
        <Box h={42} mt={2}>
          {/* achieved */}
          <Box
            style={{
              width: raisedLength,
              height: "6px",
              borderRadius: "3px",
            }}
            backgroundColor="#01BFBD"
          ></Box>
          {/* Target */}
          <Box
            style={{
              width: "100%",
              height: "6px",
              borderRadius: "3px",
              position: "relative",
              marginTop: "-6px",
            }}
            backgroundColor="#01BFBD4D"
          ></Box>
        </Box>
      </Box>

      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "320px",
          height: "30px",
          padding: "0px 20px",
          marginTop: "8px",
          marginBottom: "2px",
        }}
      >
        <Box>
          <span>
            <AiOutlineClockCircle
              style={{ height: "20px", width: "20px", marginTop: "0px" }}
            />
          </span>
          <span
            style={{
              margin: "5px",
              fontSize: "17px",
              fontWeight: "bold",
              position: "relative",
              top: "-20px",
              left: "20px",
            }}
          >
            {days}
          </span>
          <span
            style={{
              position: "relative",
              top: "-22px",
              left: "20px",
              fontSize: "12px",
            }}
          >
            {/* Days left */}
          </span>
        </Box>
        <Box mr={5}>
          <AiFillHeart
            color="red"
            style={{
              height: "24px",
              width: "24px",
              marginTop: "-2px",
            }}
          />
          <span
            style={{
              margin: "5px",
              fontSize: "17px",
              fontWeight: "bold",
              position: "relative",
              top: "-22px",
              left: "20px",
              marginLeft: "7px",
            }}
          >
            {supporters}
          </span>
          <span
            style={{
              position: "relative",
              top: "-24px",
              left: "20px",
              fontSize: "12px",
            }}
          >
            {/* Supporters */}
          </span>
        </Box>
      </Box>
      {/* </Box> */}
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginLeft: "14px",
          marginTop: "0px",
          width: "288px",
          height: "62px",
        }}
      >
        <Box
          style={{
            width: "137px",
            height: "42px",
            border: "1px solid #4867aa",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <AiFillFacebook
            color="#4867aa"
            style={{
              height: "16px",
              width: "16px",
            }}
          />
          <span
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "#4867aa",
              marginTop: "2px",
              marginLeft: "5px",
            }}
          >
            Share
          </span>
        </Box>
        <Box
          style={{
            width: "137px",
            height: "42px",
            borderRadius: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#52c0bd",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "white",
              marginTop: "0px",
              marginLeft: "5px",
            }}
          >
            Donate
          </span>
        </Box>
      </Box>
    </Box>
  );
};

export default ImgCard;
